/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-13 19:28:40
 * @Description: 后台路由
 */
"use strict";
angular.module("backstageRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("backstage", {
        url: "/backstage",
        views: {
            "header@backstage": {
                templateUrl: 'header/backstageHeader_tpl.html',
                controller: 'backstageHeaderCtrl'
            },
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body">' +
                    '<div class="view_sidebar" ui-view="left"></div>' +
                    '<div class="view_content view_content_full backstage" ui-view="main"></div>' +
                    '</div>',
                controller: "backstageCtrl"
            },
            "left@backstage": {
                templateUrl: './main/backstage/backstageLeft_tpl.html',
                controller: 'backstageLeftCtrl'
            }
        }
    });
}]).run(['$rootScope', '$window', '$location', '$log', function ($rootScope, $window, $location, $log) {  
	/**
	 * [路由变化做的事 先放这里 description] 
	 * @return {[type]} [description]
	 */
    var locationChangeStartOff = $rootScope.$on('$locationChangeStart', locationChangeStart);  
    var locationChangeSuccessOff = $rootScope.$on('$locationChangeSuccess', locationChangeSuccess);  
  
    var routeChangeStartOff = $rootScope.$on('$routeChangeStart', routeChangeStart);  
    var routeChangeSuccessOff = $rootScope.$on('$routeChangeSuccess', routeChangeSuccess);  
  
    function locationChangeStart(event) {  
//      $log.log('locationChangeStart');  
//      $log.log(arguments);  
    }  
  
    function locationChangeSuccess(event) {  
//      $log.log('locationChangeSuccess');  
//      $log.log(arguments);  
    }  
  
    function routeChangeStart(event) {  
//      $log.log('routeChangeStart');  
//      $log.log(arguments);  
    }  
  
    function routeChangeSuccess(event) {  
//      $log.log('routeChangeSuccess');  
//      $log.log(arguments);  
    }  
}]);